// extracted by mini-css-extract-plugin
export default {"bold":"style--bold--b5610c","borderRight":"style--borderRight--1d53aa","textAlignRight":"style--textAlignRight--41c314"};